<template lang="">
    <div ref="counter_quantity" class="counterComponent">
        <slot name="counter_component" v-bind="this"></slot>
    </div>
</template>
<script>
export default {
    props: {
        inventory_quantity: null,
        product_id_variant: null,
        product_name: null,
        type_view: null
    },
    data() {
        return {
            counter_product: 1,
            formData: null,
            totalProductInCart: 0,
            totalToAdd: 0,
            btnDecrease: null,
            btnIncrease: null,
            btnAdd: null,
            qtyInput: null,
            isMinusDisabledClass: true,
            isPlusDisabledClass: false,
            isMinusDisabledProperty: false,
            isPlusDisabledProperty: false,
            isBtnAddDisabledProperty: false,
            isBtnAddDisabledClass: false,
            isQtyInputDisabledProperty: false,
            isQtyInputDisebledClass: false,
            isMaxStock: false,
            isMaxExceded: false,
            isLimitAvaliable: false,
            isLoading: false,
            payloadAddProduct: null
        }
    },
    methods: {
        decreaseTotal() {
            if(this.counter_product > 1) {
                this.counter_product -= 1;
                this.disableMinus(0);
                this.disablePlus();
                this.checkLimitStock();
            } else if(this.counter_product == 1) {
                this.counter_product = 1;
                this.isMinusDisabledClass = true;

                this.isMinusDisabledProperty = false;
                this.isPlusDisabledClass = false;
            }
        },
        increaseTotal() {
            this.counter_product += 1;
            this.disableMinus(1);
            this.disablePlus();
            this.checkLimitStock();
        },
        disableMinus(validation) {
            if(validation == 0) {
                setTimeout(() => {
                    if(this.counter_product == 1) {
                        this.counter_product = 1;
                        this.isMinusDisabledProperty = true;
                        this.isMinusDisabledClass = true;
                    } else {
                        this.isPlusDisabledProperty = false;
                        this.isMinusDisabledClass = false;
                    }
                }, 500);
            } else if(validation == 1) {
                setTimeout(() => {
                    if(this.counter_product > 1) {
                        this.isMinusDisabledProperty = false;
                        this.isMinusDisabledClass = false;

                    } else if(this.counter_product == 1) {
                        this.isMinusDisabledProperty = true;
                        this.isMinusDisabledClass = true;
                    }
                }, 500);
            }
        },
        disablePlus() {
            if(this.counter_product === parseInt(this.inventory_quantity)) {
                this.isPlusDisabledProperty = true;
                this.isPlusDisabledClass = true;

            } else if(this.counter_product < parseInt(this.inventory_quantity)) {
                this.isPlusDisabledProperty = false;
                this.isPlusDisabledClass = false;

            } else if(this.counter_product > parseInt(this.inventory_quantity)) {
                this.isPlusDisabledProperty = true;
                this.isPlusDisabledClass = true;

            }
        },
        disableBtnAdd() {
            if(this.counter_product > parseInt(this.inventory_quantity)) {
                this.isBtnAddDisabledClass = true;
                this.isBtnAddDisabledProperty = true;
            } else {
                this,this.isBtnAddDisabledClass = false;
                this,this.isBtnAddDisabledProperty = false;
            }
        },
        disabledCounter(type_validation) {
            if(type_validation == true) {
                this.isBtnAddDisabledProperty = true;
                this.isBtnAddDisabledClass = true;
                this.isQtyInputDisabledProperty = true;
                this.isQtyInputDisebledClass = true;
                this.isLoading = true;
            } else {
                setTimeout(() => {
                    this.isBtnAddDisabledProperty = false;
                    this.isBtnAddDisabledClass = false;
                    this.isQtyInputDisabledProperty = false;
                    this.isQtyInputDisebledClass = false;
                    this.isLoading = false;
                    this.counter_product = 1;
                }, 2500);
            }
        },
        checkLimitStock() {
            this.counter_product === parseInt(this.inventory_quantity) ? this.isMaxStock = true : this.isMaxStock = false;
        },
        submit(event) {
            event.preventDefault();

            soCartManager.get().then((cart) => {
                let itemsCart = cart.items;

                if(itemsCart.length === 0) {
                    this.disabledCounter(true);
                    
                    setTimeout(() => {
                        this.getPayload(false).then((payload) => {
                            soCartManager.add(payload);
                        })
                        this.totalToAdd = 0;
                    }, 1000);

                } else {
                    for (let item in itemsCart){
                        if(itemsCart[item].variant_id == parseInt(this.product_id_variant)) {
                            let itemProduct = itemsCart[item];
                            this.existProduct = true;
                            this.totalProductInCart = itemProduct.quantity;
                            return this.totalProductInCart;
                        }
                    }
                }

            }).then(() => {
                this.totalToAdd = this.totalProductInCart + this.counter_product;

                if(
                    (this.totalProductInCart == 0 && this.counter_product == this.inventory_quantity) || 
                    (this.totalProductInCart == 0 && this.counter_product < this.inventory_quantity)
                ) {
                    this.isLimitAvaliable = false;
                    this.disabledCounter(true);
                    
                    setTimeout(() => {
                        this.getPayload(false).then((payload) => {
                            soCartManager.add(payload);
                        });
                        this.totalToAdd = 0;
                    }, 1000);


                } else if(
                    this.totalProductInCart != 0 && 
                    this.counter_product == parseInt(this.inventory_quantity) && 
                    this.totalToAdd < parseInt(this.inventory_quantity)) {

                    let counter_product_new = parseInt(this.inventory_quantity) - this.totalProductInCart;
                    this.counter_product = counter_product_new;
                    this.isLimitAvaliable = true;
                    this.disabledCounter(true);

                    setTimeout(() => {
                        this.isLimitAvaliable = true;
                        this.getPayload(false).then((payload) => {
                            soCartManager.add(payload);
                        });
                        this.totalToAdd = 0;
                    }, 1000);

                } else if(
                    (this.totalProductInCart != 0 && this.totalToAdd < parseInt(this.inventory_quantity)) ||
                    this.totalProductInCart != 0 && this.totalToAdd == parseInt(this.inventory_quantity)) {

                    this.disabledCounter(true);

                    setTimeout(() => {
                        this.getPayload(false).then((payload) => {
                            soCartManager.add(payload);
                        });
                        this.totalToAdd = 0;
                    }, 1000);

                } else if(
                    (this.totalProductInCart == parseInt(this.inventory_quantity) && 
                    this.counter_product == parseInt(this.inventory_quantity) && 
                    this.totalToAdd > parseInt(this.inventory_quantity)) ||
                    
                    (this.totalProductInCart == parseInt(this.inventory_quantity) && 
                    this.counter_product < parseInt(this.inventory_quantity) && 
                    this.totalToAdd > parseInt(this.inventory_quantity))) {

                    this.isLimitAvaliable = true;
                    this.totalToAdd = 0;
                    this.counter_product = 1;
                    event.preventDefault();
                    
                } else if(
                    this.totalProductInCart < parseInt(this.inventory_quantity) && 
                    this.counter_product < parseInt(this.inventory_quantity) && 
                    this.totalToAdd > parseInt(this.inventory_quantity) ||
                
                    this.totalProductInCart < parseInt(this.inventory_quantity) && 
                    this.counter_product == parseInt(this.inventory_quantity) && 
                    this.totalToAdd > parseInt(this.inventory_quantity)) {

                    this.isLimitAvaliable = true;

                    this.disabledCounter(true);

                    setTimeout(() => {
                        this.getPayload(true).then((payload) => {
                            soCartManager.add(payload);
                        });
                        this.totalToAdd = 0;
                    }, 1000);
                } else {
                    this.totalToAdd = 0;
                    this.counter_product = 1;
                }
            }).then(() => {
                this.disabledCounter(false);

                if(this.type_view === 'product' && (this.isMaxStock === true || this.isMaxExceded === true || this.isLimitAvaliable === true)) {
                    setTimeout(() => {
                        this.isMaxStock = false;
                        this.isMaxExceded = false;
                        this.isLimitAvaliable = false;
                    }, 3500);
                }

            }).catch(error => {
                console.error(error);
            });
        },
        getPayload(max) {
            let payload = [];

            return new Promise((resolve, reject) => {
                const formElem = new FormData(this.formData);

                let payloadTwo = {
                    'items': [{
                        'available_variant': parseInt(this.inventory_quantity)
                    }]
                }

                if(max == false) {
                    payload = [{
                        'id': formElem.get('id'),
                        'quantity': formElem.get('quantity')
                    }];

                } else {
                    let new_quantity = parseInt(this.inventory_quantity) - this.totalProductInCart;
                    formElem.delete('quantity');
                    formElem.set('quantity', new_quantity);
                    
                    payload = [{
                        'id': formElem.get('id'),
                        'quantity': formElem.get('quantity')
                    }];
                }

                if(payload) {
                    resolve(payload, payloadTwo);
                } else {
                    reject('Error al crear el payload');
                }
            });
        },
        handleKeyDown(e, availability) {
            setTimeout(() => {
                this.counter_product = parseInt(e.target.value);

                if(this.counter_product > parseInt(this.inventory_quantity)) {
                    this.isMaxExceded = true;
                    this.disablePlus();
                    this.checkLimitStock();
                    this.disableBtnAdd();

                    if(this.isLimitAvaliable == true) {
                        this.isLimitAvaliable = false;
                    }
                } else {
                    this.isMaxExceded = false;
                    this.disablePlus();
                    this.disableBtnAdd();
                }

                if(this.counter_product == 0) {
                    this.counter_product = 1;
                    this.qtyInput.value = this.counter_product;
                }

                if(Number.isNaN(parseInt(e.target.value)) == false) {
                    this.counter_product = Math.round(parseInt(e.target.value));
                }

                if(this.counter_product < 0){
                    this.counter_product = 1;
                }
                var code = (e.which) ? e.which : e.keyCode;

                if (e.target.value === "NaN" || this.qtyInput.value == '') {
                    this.counter_product = 1;
                }
            }, 100);


            if(e.keyCode == 37) {
                this.decreaseTotal();

            } else if(e.keyCode == 39) {
                if(this.counter_product < availability){
                    this.increaseTotal();
                }
                
            } else if(e.keyCode == 38) {
                this.disableMinus(1);
                this.increaseTotal();

                if(this.counter_product === parseInt(this.inventory_quantity)) {
                    this.isMaxStock = true;
                    this.disablePlus(0);
                    this.counter_product = availability;
                    e.preventDefault();
                    this.qtyInput.type = 'text';
                }
                
            } else if(e.keyCode == 40) {
                if(this.counter_product == 1) {
                    this.counter_product = 1;
                    this.isMinusDisabledClass = true;
                    this.isPlusDisabledProperty = false;
                    this.isPlusDisabledClass = false;

                } else if(this.counter_product < parseInt(this.inventory_quantity)) {
                    this.isMaxStock = false;
                    this.isPlusDisabledClass = false;
                    this.disablePlus();
                    this.decreaseTotal();
                }
            } else if(e.keyCode == 13) {
                this.submit(e);
            }

            if(e.target.value.length === 4){
                this.qtyInput.value = this.qtyInput.value.slice(0, 4)
            }
        },
        handleQuantityFocus(e) {
            this.counter_product = parseInt(e.target.value);
            this.disablePlus();

            if(e.target.value == "" || this.counter_product === 0) {
                this.counter_product = 1;

                if(this.counter_product === 1) {
                    this.isPlusDisabledProperty = false;
                    this.isPlusDisabledClass = false;
                }
            }
        },
        handleKeyPress(e) {
            
        },
        verifyStock() {
            if(this.inventory_quantity == 0) {
                this.isMinusDisabledClass = true;
                this.isPlusDisabledClass = false;
                this.isMinusDisabledProperty = true;
                this.isPlusDisabledProperty = true;

            } else if(this.inventory_quantity == 1) {
                this.isMinusDisabledClass = true;
                this.isPlusDisabledClass = true;
                this.isMinusDisabledProperty = true;
            }
        }
    },
    mounted() {
        this.formData = this.$refs.counter_quantity.querySelector('#formElem');
        this.qtyInput = this.$refs.counter_quantity.querySelector('.qtyInput');
        this.btnDecrease = this.$refs.counter_quantity.querySelector('.quantity__button--decrease');
        this.btnIncrease = this.$refs.counter_quantity.querySelector('.quantity__button--increment');
        this.btnAdd = this.$refs.counter_quantity.querySelector('.cartbutton');
        this.qtyInput.maxLength = 4;
        this.counter_product = parseInt(this.counter_product);
        this.verifyStock();
        this.disableMinus(0);
    },
}
</script>
<style lang="">
    
</style>